export const VISUAL_TYPE = "tables";
export const VERSION = process.env.VERSION;
export const PRODUCT = "Zebra BI Tables for Office";
